import { getAjaxhelper } from './CoreAjaxHelper';

export function requestToken(): Promise<string> {
    return new Promise<string>((accept: (n: any) => any, ) => { 
        getAjaxhelper().get(`/dynamics/rest-api/generic/BookingCancelation/double-submit-token-generator.svc`).then((data) => {
            accept(data);
        }).catch(exc => {
            console.log(exc);
        }); 
        return;
    });
}
 


// WEBPACK FOOTER //
// ./src/utils/request-token.ts